import { flow, partial, mapKeys, mapValues, isPlainObject } from 'lodash-es';

import {
  MOVING_CENTER_FETCH_SUCCESS,
  MOVING_CENTER_SUBMIT_SUCCESS,
  MOVING_CENTER_UPDATE_KIND_SUCCESS,
} from './moving-center.actions';

const INITIAL_STATE = {};

export function MovingCenterReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case MOVING_CENTER_FETCH_SUCCESS:
    case MOVING_CENTER_SUBMIT_SUCCESS:
    case MOVING_CENTER_UPDATE_KIND_SUCCESS:
      const data = desalesforcify(action.payload);

      return {
        ...state,
        [data.updater_move_id]: data,
      };

    default:
      return state;
  }
}

// Recursively format Salesforce-style variable names, removing the `__c` ending.
const desalesforcify = flow(
  partial(mapKeys, partial.placeholder, (value, key) =>
    key.toLowerCase().replace(/__c$/, '')
  ),
  partial(mapValues, partial.placeholder, value => {
    if (isPlainObject(value)) {
      return desalesforcify(value);
    } else if (Array.isArray(value)) {
      return value.map(desalesforcify);
    } else {
      return value;
    }
  })
);
